import * as Types from '../mutationTypes';
import HestiaApi  from '@/api';

// initial state
const state = {
  lots : {
    results    : [],
    pagination : {
      perPage : 10,
      page    : 1,
      total   : 0
    }
  }
};

// getters
const getters = {
  lots : state => state.lots
};

// actions
const actions = {

  // LOT
  async getLots({ commit }, { tenantId, query }) {

    const response = await HestiaApi.Commercialisation.lot.list(tenantId, { searchParams : query }).json();
    commit(Types.RECEIVE_LOTS, response);
  },
  async editLot({ commit }, { tenantId, id, lot }) {

    const response = await HestiaApi.Commercialisation.lot.update(tenantId, id, lot).json();

    commit(Types.EDIT_LOT, response);
  }
};

// mutations
const mutations = {
  [Types.RECEIVE_LOTS](state, lots) {

    state.lots = lots;
  },
  [Types.EDIT_LOT](state, lot) {

    const index = state.lots.results.findIndex(item => item.id === lot.id);
    const program = state.lots.results[index].program;
    const hasBooking = state.lots.results[index].hasBooking;

    state.lots.results.splice(index, 1, {
      program    : program,
      hasBooking : hasBooking,
      ...lot
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
